/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button } from 'reactstrap';
import TheLayout from '../../layout/TheLayout';
import FormTable from './formTable';
import SuccessModal from '../Util/Modal/SuccessModal';
import FailureModal from '../Util/Modal/FailureModal';
import {
  updateCustomer,
  clearResultFlg,
} from '../../redux/actions/mypage';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const Profile = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const customer = useSelector((state) => state.auth.customer, shallowEqual);
  const isSuccess = useSelector((state) => state.mypage.isSuccess, shallowEqual);
  const isFailure = useSelector((state) => state.mypage.isFailure, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  // form table
  const [formTable, setFormTable] = useState({
    familyName: customer?.family_name || '',
    firstName: customer?.first_name || '',
    familyNameKana: customer?.family_name_kana || '',
    firstNameKana: customer?.first_name_kana || '',
    phoneNumber: customer?.phone_number || '',
    zipCode: customer?.zip_code || '',
    prefectureId: customer?.prefecture_id || '',
    address1: customer?.address_first || '',
    address2: customer?.address_second || '',
    address3: customer?.address_third || '',
    email: customer?.email || '',
  });
  // form table error
  const [formTableError, setFormTableError] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '',
    address1: '',
    address2: '',
    email: '',
  });
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isFailure]);
  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }
  const onSubmit = () => {
    let isInvalid = false;
    setFormTableError({
      familyName: '',
      firstName: '',
      familyNameKana: '',
      firstNameKana: '',
      phoneNumber: '',
      zipCode: '',
      prefectureId: '',
      address1: '',
      address2: '',
      email: '',
    });
    if (formTable.familyName === '') {
      setFormTableError((formTableError) => ({ ...formTableError, familyName: '氏を入力してください' }));
      isInvalid = true;
    }
    if (formTable.firstName === '') {
      setFormTableError((formTableError) => ({ ...formTableError, firstName: '名を入力してください' }));
      isInvalid = true;
    }
    if (formTable.familyNameKana === '') {
      setFormTableError((formTableError) => ({ ...formTableError, familyNameKana: 'セイを入力してください' }));
      isInvalid = true;
    }
    if (formTable.firstNameKana === '') {
      setFormTableError((formTableError) => ({ ...formTableError, firstNameKana: 'メイを入力してください' }));
      isInvalid = true;
    }
    if (formTable.phoneNumber === '') {
      setFormTableError((formTableError) => ({ ...formTableError, phoneNumber: '電話番号を入力してください' }));
      isInvalid = true;
    }

    if (formTable.zipCode === '') {
      setFormTableError((formTableError) => ({ ...formTableError, zipCode: '郵便番号を入力してください' }));
      isInvalid = true;
    }
    if (formTable.prefectureId === '0') {
      setFormTableError((formTableError) => ({ ...formTableError, prefectureId: '都道府県を選択してください' }));
      isInvalid = true;
    }
    if (formTable.address1 === '') {
      setFormTableError((formTableError) => ({ ...formTableError, address1: '市区町村を入力してください' }));
      isInvalid = true;
    }
    if (formTable.address2 === '') {
      setFormTableError((formTableError) => ({ ...formTableError, address2: '建物号室を入力してください' }));
      isInvalid = true;
    }
    if (formTable.email === '') {
      setFormTableError((formTableError) => ({ ...formTableError, email: 'メールアドレスを入力してください' }));
      isInvalid = true;
      // eslint-disable-next-line no-useless-escape
    } else if (!formTable.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
      setFormTableError((formTableError) => ({ ...formTableError, email: 'メールアドレスが不正です' }));
      isInvalid = true;
    }

    if (isInvalid) return;
    const param = {
      family_name: formTable.familyName,
      first_name: formTable.firstName,
      family_name_kana: formTable.familyNameKana,
      first_name_kana: formTable.firstNameKana,
      phone_number: formTable.phoneNumber,
      zip_code: formTable.zipCode,
      prefecture_id: Number(formTable.prefectureId),
      address_first: formTable.address1,
      address_second: formTable.address2,
      email: formTable.email,
    };
    dispatch(updateCustomer(accessToken, param));
  };

  const closeResultModal = () => {
    dispatch(clearResultFlg());
  };

  const gotoMypage = () => {
    dispatch(clearResultFlg());
    history.push('/mypage');
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>基本情報の変更｜株式会社TERRA</title>
      </Helmet>
      <div className="profile" style={{ background: 'rgb(235, 244, 246)' }}>
        <div className="d-none d-lg-block">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb bg-transparent" style={{ color: 'rgb(181,189,185)', background: 'rgb(235, 244, 246)!important' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/mypage">マイページ</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>基本情報の変更</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-5">
          <div
            className="information bg-white px-5"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h4 className="row border-bottom py-2" style={{ color: 'rgb(71,108,138)' }}>基本情報の変更</h4>
            <div className="row py-2">
              <FormTable
                form={formTable}
                formError={formTableError}
                onChange={(e) => setFormTable({ ...formTable, [e.target.name]: e.target.value })}
              />
            </div>
            <div className="row p-4">
              <Button
                style={{
                  background: 'rgb(34,75,113)',
                  border: 'solid 1px rgb(34,75,113)',
                  color: 'white',
                  height: '2rem',
                  lineHeight: '2rem',
                  borderRadius: '1rem',
                  padding: '0 50px',
                  float: 'right',
                  margin: 'auto',
                }}
                onClick={onSubmit}
              >
                変更
              </Button>
            </div>
          </div>
          {/* 成功モーダル */}
          <SuccessModal
            isOpen={isSuccess}
            onclickOK={gotoMypage}
            message="登録情報の変更が完了しました"
          />
          {/* 失敗モーダル */}
          <FailureModal
            isOpen={isFailure}
            onclickOK={closeResultModal}
            message="登録情報の変更に失敗しました。"
            detail="時間を置いてもう一度お試しください。"
          />
        </div>
      </div>
    </TheLayout>
  );
};

export default Profile;
